<div
	*ngIf="!isModuleActive"
	class="text-muted atlas-spacing-mb-4 disabled-module-title"
>
	<i class="bi bi-exclamation-circle"></i>
	<span class="atlas-spacing-ms-1"
		>Módulo desativado pois nenhuma opção está selecionada
	</span>
</div>
<div class="form-check atlas-spacing-mb-4">
	<input
		#checkAll
		[checked]="isAllNodesPerModuleChecked"
		(change)="selectAllNodesPerModule(checkAll)"
		class="form-check-input"
		type="checkbox"
		id="mark-all"
		[disabled]="disabled"
	/>
	<label class="form-check-label text-dark" for="mark-all">
		Selecionar todos
	</label>
</div>

<div class="accordion accordion-flush">
	<div
		*ngFor="let node of dataSource; let i = index"
		class="accordion-item atlas-spacing-mb-3"
	>
		<div class="accordion-header">
			<div class="d-flex align-items-start">
				<button
					*ngIf="accordionBtnPosition === 'left'"
					class="accordion-button btn-accordion me-2 collapsed"
					type="button"
					data-bs-toggle="collapse"
					[attr.data-bs-target]="'#collapseExample' + i"
					[attr.aria-controls]="'collapseExample' + i"
					aria-expanded="false"
				></button>

				<input
					[checked]="descendantsAllSelected(node)"
					[indeterminate]="descendantsPartiallySelected(node)"
					class="me-2 form-check-input"
					type="checkbox"
					[id]="'flexCheckAll' + i"
					(change)="selectEntireNode(node)"
					[disabled]="disabled"
				/>
				<span
					class="text-dark"
					[class.accordion-header-disabled]="disabled"
					>{{ node.titulo }}</span
				>

				<button
					*ngIf="accordionBtnPosition === 'right'"
					class="accordion-button btn-accordion collapsed"
					type="button"
					data-bs-toggle="collapse"
					[attr.data-bs-target]="'#collapseExample' + i"
					[attr.aria-controls]="'collapseExample' + i"
					aria-expanded="false"
				></button>
			</div>
		</div>
		<div [id]="'collapseExample' + i" class="accordion-collapse collapse">
			<div
				class="ms-4 accordion-body atlas-spacing-pt-3 pb-0"
				[class.container-mobile]="accordionBtnPosition === 'left'"
			>
				<div class="row">
					<div class="col-12 col-lg-6">
						<ng-container *ngIf="node.funcionalidadeMenusFilhos">
							<ng-container
								*ngFor="
									let childNode of sliceNodeEvents(
										node.funcionalidadeMenusFilhos
									)[0];
									let i = index
								"
							>
								<div class="form-check atlas-spacing-mb-2">
									<input
										class="form-check-input"
										type="checkbox"
										value=""
										[id]="
											'flexCheck' +
											i +
											childNode.titulo +
											childNode.id
										"
										[checked]="
											isSingleNodeSelected(childNode)
										"
										(change)="
											selectSingleChildNode(
												childNode,
												node.id
											)
										"
										[disabled]="disabled"
									/>
									<label
										class="form-check-label"
										[for]="
											'flexCheck' +
											i +
											childNode.titulo +
											childNode.id
										"
									>
										{{ childNode.titulo }}
									</label>
								</div>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="node.eventos">
							<ng-container
								*ngFor="
									let childNode of sliceNodeEvents(
										node.eventos
									)[0];
									let i = index
								"
							>
								<div class="form-check atlas-spacing-mb-2">
									<input
										class="form-check-input"
										type="checkbox"
										value=""
										[id]="
											'flexCheck' +
											i +
											childNode.titulo +
											node.id
										"
										[checked]="
											isSingleNodeSelected(childNode)
										"
										(change)="
											selectSingleChildNode(
												childNode,
												node.id
											)
										"
										[disabled]="disabled"
									/>
									<label
										class="form-check-label"
										[for]="
											'flexCheck' +
											i +
											childNode.titulo +
											node.id
										"
									>
										{{ childNode.titulo }}
									</label>
								</div>
							</ng-container>
						</ng-container>
					</div>
					<div class="col-12 col-lg-6">
						<ng-container *ngIf="node.funcionalidadeMenusFilhos">
							<ng-container
								*ngFor="
									let childNode of sliceNodeEvents(
										node.funcionalidadeMenusFilhos
									)[1];
									let i = index
								"
							>
								<div class="form-check atlas-spacing-mb-2">
									<input
										class="form-check-input"
										type="checkbox"
										value=""
										[id]="
											'flexCheck' +
											i +
											'col' +
											childNode.titulo +
											childNode.id
										"
										[checked]="
											isSingleNodeSelected(childNode)
										"
										(change)="
											selectSingleChildNode(
												childNode,
												node.id
											)
										"
										[disabled]="disabled"
									/>
									<label
										class="form-check-label"
										[for]="
											'flexCheck' +
											i +
											'col' +
											childNode.titulo +
											childNode.id
										"
									>
										{{ childNode.titulo }}
									</label>
								</div>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="node.eventos">
							<ng-container
								*ngFor="
									let childNode of sliceNodeEvents(
										node.eventos
									)[1];
									let i = index
								"
							>
								<div class="form-check atlas-spacing-mb-2">
									<input
										class="form-check-input"
										type="checkbox"
										value=""
										[id]="
											'flexCheck' +
											i +
											'col' +
											childNode.titulo +
											node.id
										"
										[checked]="
											isSingleNodeSelected(childNode)
										"
										(change)="
											selectSingleChildNode(
												childNode,
												node.id
											)
										"
										[disabled]="disabled"
									/>
									<label
										class="form-check-label"
										[for]="
											'flexCheck' +
											i +
											'col' +
											childNode.titulo +
											node.id
										"
									>
										{{ childNode.titulo }}
									</label>
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
